import { SignerAppClient } from 'signer-app/context/signer-app-client';
import type { AppLogSnapshot } from 'signer-app/utils/log-app-actions';
import { logAppActionsInDevelopment } from 'signer-app/utils/log-app-actions';
import {
  LazyInitaizlizer,
  makeLazyClient,
} from 'signer-app/utils/make-lazy-client';
import { wrapNamespace } from 'signer-app/utils/network-delay';

export const allMockUsers = [
  'default',
  'LaurenIpsum',
  'Free',
  'Empty Platinum',
  'FreeApiEligibleForTemplate',
  'Has signed data',
  'Mismatched fields',
  'SandBoxedLeoUser',
  'DropboxManagedUser',
  'DropboxManagedUserWithDbx1StandardPlan',
  'PaidUser',
  'With distinct PDFs enabled',
] as const;

/**
 * LaurenIpsum is a generic user for when you need mock actions that return some
 * fixed data. See account-settings-mock for an example.
 */
export type MockUserName = (typeof allMockUsers)[number];

const lazy: LazyInitaizlizer<SignerAppClient> = {
  /* eslint-disable @typescript-eslint/no-var-requires */
  /* eslint-disable global-require */
  signer: (mockUserName) => {
    const MockSigner =
      require('signer-app/context/signer-app-client/signer-mock').default;
    return wrapNamespace(new MockSigner(mockUserName));
  },
  signatures: () => {
    const MockSignature =
      require('signer-app/context/signer-app-client/signature-mock').default;
    return wrapNamespace(new MockSignature());
  },
  tours: () => {
    const MockTours =
      require('signer-app/context/signer-app-client/tours-mock.tsx').default;
    return wrapNamespace(new MockTours());
  },
  signerApi: () => {
    const {
      SignerAppApiMock,
    } = require('signer-app/context/signer-app-client/signer-api-mock');
    return wrapNamespace(new SignerAppApiMock());
  },
  authentication: (mockUserName) => {
    const MockAuthentication =
      require('signer-app/context/signer-app-client/authentication-mock').default;
    return wrapNamespace(new MockAuthentication(mockUserName));
  },
};

export function mockSignerAppClient(
  mockUserName: MockUserName = 'default',
  snapshot?: AppLogSnapshot<SignerAppClient>,
): SignerAppClient {
  const client = makeLazyClient(lazy, mockUserName);
  return logAppActionsInDevelopment(client, snapshot, 'signerAppClient');
}
